import MemberContractState from './MemberContractState';
import MemberShortProfileBasic from './MemberShortProfileBasic';

export default class PhysicalAccessMediumIdentification {
    static fromData(data) {
        if (!data) {
            return;
        }

        const physicalAccessMediumIdentification = new PhysicalAccessMediumIdentification();
        physicalAccessMediumIdentification.id = data.id;
        physicalAccessMediumIdentification.accessMediumNumber = data.accessMediumNumber;
        physicalAccessMediumIdentification.accessMediumType = data.accessMediumType;
        physicalAccessMediumIdentification.date = data.date;
        physicalAccessMediumIdentification.accessGranted = data.accessGranted;
        physicalAccessMediumIdentification.time = data.time;
        physicalAccessMediumIdentification.member = data.member;
        if (physicalAccessMediumIdentification.member) {
            physicalAccessMediumIdentification.member.contractState = (data.member && data.member.contractState && data.member.contractState.status && data.member.contractState.contractType) ? new MemberContractState(data.member.contractState.status, data.member.contractState.contractType) : null;
        }
        physicalAccessMediumIdentification.isNew = false;
        physicalAccessMediumIdentification.terminalName = data.terminalName;

        physicalAccessMediumIdentification.shortProfile = MemberShortProfileBasic.fromData(data.member);

        Object.seal(physicalAccessMediumIdentification);
        return physicalAccessMediumIdentification;
    }
}
